import React, { useState } from "react";
import ItemPickerModal from "./ItemPickerModal";

// Staged chip editor for sibling internalCodes — picker-only, no free-text (a typed code
// that doesn't resolve is exactly the error this avoids). value order is preserved.
// Props: { value = [], onChange, items = [], selfCode, itemName, itemCategory }
export default function SiblingEditor({ value = [], onChange, items = [], selfCode, itemName, itemCategory }) {
  const [pickerOpen, setPickerOpen] = useState(false);

  const byCode = new Map(items.map((it) => [it.internalCode, it]));

  const removeAt = (i) => onChange(value.filter((_, idx) => idx !== i));

  // Candidates exclude self and codes already staged. Same name (case-insensitive) as the
  // current item ranks first, then same category, then the rest in given order.
  const pickerItems = () => {
    const excluded = new Set([selfCode, ...value].filter(Boolean));
    const candidates = items.filter((it) => !excluded.has(it.internalCode));
    const nameLower = (itemName || "").trim().toLowerCase();
    const catLower = (itemCategory || "").trim().toLowerCase();
    const rank = (it) => {
      if (nameLower && it.name.trim().toLowerCase() === nameLower) return 0;
      if (catLower && (it.category || "").trim().toLowerCase() === catLower) return 1;
      return 2;
    };
    return [...candidates].sort((a, b) => rank(a) - rank(b));
  };

  return (
    <div className="fitment-editor">
      {value.length > 0 && (
        <div className="fitment-chips">
          {value.map((code, i) => {
            const it = byCode.get(code);
            const label = it ? `${code} · ${it.name}` : `${code} · (tidak tersedia)`;
            return (
              <span key={`${code}-${i}`} className="fitment-chip">
                {label}
                <button type="button" className="fitment-chip__x" aria-label={`Hapus ${code}`}
                  onClick={() => removeAt(i)}>×</button>
              </span>
            );
          })}
        </div>
      )}
      <button type="button" className="btn btn-sm" onClick={() => setPickerOpen(true)}>
        + Tambah saudara
      </button>
      {pickerOpen && (
        <ItemPickerModal
          items={pickerItems()}
          bucket="PUSAT"
          multi
          hideTypeFilter
          onConfirm={(codes) => { onChange([...value, ...codes]); setPickerOpen(false); }}
          onClose={() => setPickerOpen(false)}
        />
      )}
    </div>
  );
}
